"use client";

import React from "react";
import Error500 from "../../../../src/components/Error500/Error500";

//Error Component for handeling error for all the pages added in (bookDetailPageLayout) route group
const error = (message) => {
  return <Error500 error={message} isNewAppRouter={true} />;
};

export default error;
